<template>
  <div
    class="Bar6Charts"
    v-loading="loading"
    element-loading-text="拼命加载中..."
    element-loading-background="rgba(0, 0, 0, 0)"
    ref="loading-box"
    @mousedown="!isEditMode && isOpenLink && echartClick($event)"
    :class="{ link: isOpenLink && !isEditMode ? true : false }"
  >
    <TableDateDownSelect
      v-if="value.isShowRightDropDownBox"
      :tabselectData="tabselectData"
      :pickerType="pickerType"
      :selectApi="selectApi"
      @tabSelectChange="tabSelectChange"
    >
    </TableDateDownSelect>
    <div class="echarts" :id="Configuration.id"></div>
    <div class="no-data" v-if="noData">
      <sapn>暂无数据！</sapn>
    </div>
  </div>
</template>

<script>
import * as Echarts from 'echarts';
import { mapState } from 'vuex';
import { jumpSomePlaceByLink, getFilterValue } from '../../../../utils/tool';
import { request } from '../../../../common/request';
import TableDateDownSelect from '@/components/common/TableDateDownSelect/TableDateDownSelect.vue';
export default {
  name: 'Bar6Charts',
  components: { TableDateDownSelect },
  props: {
    ProjectInfo: Object,
    Configuration: Object,
  },
  data() {
    return {
      echartsOptions: {},
      apiIntervalTaskID: null,
      staticIntervalTaskID: null,
      params: {}, // 请求参数
      paramsCopy: {},
      noData: false,
      loading: true,
      value: {
        isShowRightDropDownBox: false,
      },
      tabselectData: [], // 下拉选择的时间数据d
      selectApi: '',
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function () {
        if (this.Configuration.isScaling) {
          this.throttle_resizeEcharts();
        } else if (this.Configuration.isMoving) {
          this.debounce_resizeEcharts();
        } else {
          this.debounce_subscribeConfigurationChange();
        }
      },
    },
  },
  computed: {
    ...mapState({ isEditMode: state => state.isEditMode }),
    isOpenLink() {
      return this.Configuration.propertyData?.chartLink?.value?.isOpenLink;
    },
  },
  created() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    this.registerDebounceAndThrottle();
  },
  mounted() {
    this.$nextTick(() => {
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    });
    this.getApiDataResByFilterAndResponseQuery();
    this.setStyle();
    // this.commitDarCharts()
    // 默认取api参数

    let that = this;
    let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
    // 判断 数据 为本地或动态
    this.selectApi = ChartsData;
    let params = ChartsData?.apiData?.apiPostParams || '{}';
    // console.log('aaaa',params);
    this.params = eval('(' + params + ')');
    this.paramsCopy = eval('(' + params + ')');
  },
  beforeUnmount() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    this.destroyEcharts();
    this.unRegisterDebounceAndThrottle();
  },
  methods: {
    tabSelectChange(e) {
      // 判断是否使用静态数据
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      if (ChartsData?.currenEntry === 'staticData') {
        this.echartsClick = e;
      } else {
        this.params = this.getFilterValue(e);
        this.startApiIntervalTask();
      }
    },
    getFilterValue(e) {
      return getFilterValue(e);
    },
    echartClick(e) {
      e.stopPropagation();
      console.log('点击');
      let type = this.Configuration.propertyData.chartLink.value.linkType;
      let url = this.Configuration.propertyData.chartLink.value.linkUrl;
      jumpSomePlaceByLink(type, url);
      console.log('执行后');
    },
    registerDebounceAndThrottle() {
      this.debounce_resizeEcharts = this.$_.debounce(this.resizeEcharts, 100);
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
      this.throttle_resizeEcharts = this.$_.throttle(this.resizeEcharts, 20);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_resizeEcharts.cancel();
      this.debounce_subscribeConfigurationChange.cancel();
      this.throttle_resizeEcharts.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearInterval(this.apiIntervalTaskID);
      clearInterval(this.staticIntervalTaskID);
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },

    // 根据不同的风格取不同的颜色
    setStyle() {
      let color;
      switch (this.style) {
        case 'V1Style':
          color = '#eee';
          break;
        case 'V2Style':
          color = '#eee';
          break;
        case 'V3Style':
          color = '#7fdfff';
          break;
        case 'V4Style':
          color = '#b044f8';
          break;
        case 'V5Style':
          color = '#09af60';
          break;
        default:
          color = '#eee';
          break;
      }
      this.$refs['loading-box'].style.setProperty('--color', color); // 给变量赋值
    },
    setEchartsOptions(ParamData = null) {
      if (Object.keys(ParamData).length == 0 || ParamData.source.length == 0) {
        this.noData = true;
      } else {
        this.noData = false;
      }
      let grid = {};
      let chartColor = [];
      let source = [];
      let seriesList = [];
      let unit = '';
      let tableDownData = [];
      let rotate = 0;
      let fontStyle = {
        titleColor: '#ccc',
        titleSize: 16,
        xAxisColor: '#c3dbff',
        xAxisSize: 12,
        yAxisColor: '#c3dbff',
        yAxisSize: 12,
      };
      let chartsSubTitle = '';
      let chartsSubTitleColor = '#fff';

      if (this.Configuration.propertyData.chartsColor.value.chartColor) {
        chartColor = this.Configuration.propertyData.chartsColor.value.chartColor;
      }
      if (this.Configuration.propertyData.chartsGrid.value) {
        grid = this.Configuration.propertyData.chartsGrid.value;
      }
      if (this.Configuration.propertyData?.chartUnit?.value) {
        unit = this.Configuration.propertyData.chartUnit.value;
      }
      if (this.Configuration.propertyData?.echartsRotate?.value) {
        rotate = this.Configuration.propertyData.echartsRotate.value;
      }
      if (ParamData && ParamData.source && ParamData.seriesList) {
        source = ParamData.source;
        seriesList = ParamData.seriesList;
        tableDownData = ParamData?.tableDownData; // 日期选择需要的
      }
      if (this.Configuration.propertyData.fontStyle.value) {
        fontStyle = this.Configuration.propertyData.fontStyle.value;
      }
      if (this.Configuration.propertyData?.chartsSubTitle?.value) {
        chartsSubTitle = this.Configuration.propertyData.chartsSubTitle.value;
      }
      if (this.Configuration.propertyData?.chartsSubTitleColor?.value) {
        chartsSubTitleColor = this.Configuration.propertyData.chartsSubTitleColor.value;
      }
      if (this.Configuration.propertyData?.chartsRightDropDown?.value) {
        this.value = this.Configuration.propertyData.chartsRightDropDown.value;
      }

      let colors = [
        '#00ffff',
        '#14ff00',
        '#00e98c',
        'rgba(237,214,102,1)',
        'rgba(77,168,222,1)',
        'rgba(25,168,164,1)',
        '#222e39',
      ];
      let xAixDataList = [];
      let yAixDataList = [];
      let yAixDataList_max = [];
      let colorIndex = 0;

      // 时间
      let that = this;
      function dealSelectData() {
        let tabselectData = [];
        let pickerType = [];
        if (tableDownData) {
          tableDownData.forEach(item_t => {
            tabselectData.push(
              item_t[0], //  tabMont  tabYear
              item_t[2],
            );
            pickerType.push(item_t[1]);
          });
        }

        that.tabselectData = tabselectData;
        that.pickerType = pickerType;
      }
      console.log(chartColor, '242352452342342342');
      if (this.value.isShowRightDropDownBox) {
        dealSelectData();
      }

      function DealData() {
        seriesList.forEach(s => {
          source.forEach((item, index) => {
            if (s === item.s) {
              xAixDataList.push(item.x);
              if (colorIndex > 6) colorIndex = 0;

              yAixDataList.push({
                value: item.y,
                itemStyle: {
                  color: chartColor[colorIndex],
                },
              });
              colorIndex++;
            }
          });
        });
        yAixDataList.forEach(() => {
          yAixDataList_max.push(Math.max(...yAixDataList));
        });
      }

      DealData();

      this.echartsOptions = {
        backgroundColor: this.Configuration.propertyData.chartsColor.value.chartBackgroundColor,
        title: {
          text: chartsSubTitle,
          x: 'center',
          y: '4%',
          textStyle: {
            color: chartsSubTitleColor,
            fontSize: this.$h_Ratio(22, this.$store),
          },
          subtextStyle: {
            color: '#90979c',
            fontSize: this.$h_Ratio(16, this.$store),
          },
        },
        tooltip: {
          trigger: 'axis',
          //提示框组件，鼠标悬浮在图表上，有相应提示框
          className: 'echarts-tooltip echarts-tooltip-dark',
          textStyle: {
            color: '#fff',
            fontSize: this.$h_Ratio(12, this.$store),
          },
          // formatter: function (params) {
          //   let str = '';
          //   for (let i = 0; i < params.length; i++) {
          //     if (params[i].seriesName !== '') {
          //       str += params[i].seriesName + ': ' + params[i].value + '<br/>';
          //     }
          //   }
          //   return str;
          // },
        },
        grid: {
          ...grid,
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: xAixDataList,
            axisLine: {
              lineStyle: {
                color: 'rgba(255,255,255,0.12)',
              },
            },
            axisLabel: {
              margin: 10,
              color: fontStyle.xAxisColor,
              // 文字倾斜度
              rotate: rotate,
              textStyle: {
                fontSize: this.$h_Ratio(fontStyle.xAxisSize, this.$store),
              },
            },
          },
        ],
        yAxis: [
          {
            name: unit,
            nameTextStyle: {
              color: '#fff',
              nameLocation: 'start',
              fontSize: this.$h_Ratio(12, this.$store),
            },
            axisLabel: {
              color: fontStyle.yAxisColor,
              textStyle: {
                fontSize: this.$h_Ratio(fontStyle.yAxisSize, this.$store),
              },
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: 'rgba(255,255,255,1)',
              },
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: 'rgba(255,255,255,0.12)',
              },
            },
          },
        ],
        series: [
          {
            type: 'bar',
            data: yAixDataList,
            barWidth: this.$h_Ratio(20, this.$store),
            itemStyle: {
              normal: {
                color: new Echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: 'rgba(0,244,255,1)', // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: 'rgba(0,77,167,1)', // 100% 处的颜色
                    },
                  ],
                  false,
                ),
                barBorderRadius: [30, 30, 30, 30],
                shadowColor: 'rgba(0,160,221,1)',
                shadowBlur: 4,
              },
            },
            label: {
              show: true,
              position: 'top',
              color: '#fff',
            },
          },
        ],
      };
      // 关闭加载
      this.$nextTick(() => {
        this.loading = false;
      });
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;
      if (ChartsData?.currenEntry === 'staticData' && chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let func = () => {
          this.setEchartsOptions(ChartsData.staticData);
          this.$nextTick(() => {
            this.createEcharts();
          });
        };
        func();
        this.staticIntervalTaskID = setInterval(() => {
          func();
        }, chartsAnimation?.staticRefreshIntervalTime * 1000);
      } else if (ChartsData?.currenEntry === 'staticData') {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
        this.$nextTick(() => {
          this.createEcharts();
        });
      }
    },
    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      // 判断是否使用apiData，使用动态interval请求
      if (ChartsData?.currenEntry === 'apiData' && ChartsData?.apiData?.isUseInterval) {
        // 开启interval任务 间隔请求
        let func = async () => {
          let res = await this.getApiDataResByFilterAndResponseQuery();
          this.setEchartsOptions(res);
          this.$nextTick(() => {
            this.createEcharts();
          });
        };
        func();
        this.apiIntervalTaskID = setInterval(async () => {
          // console.log('开启interval任务 间隔请求');
          func();
        }, ChartsData?.apiData?.apiInterval * 1000);
        // console.log(ChartsData?.apiData?.apiInterval);
      } else if (ChartsData?.currenEntry === 'apiData') {
        // console.log('不开启interval任务 只处理一次请求');
        let res = await this.getApiDataResByFilterAndResponseQuery();
        this.setEchartsOptions(res);
        this.$nextTick(() => {
          this.createEcharts();
        });
      }
    },
    // promise 返回api链接的请求数据
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let that = this;
      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');
        let header;
        if (ChartsData.apiData?.isUseUserKey) {
          let user_key = localStorage.getItem('user_key');

          if (user_key == 'undefined' || user_key == 'null' || user_key == null) user_key = this.$userKey;
          header = {
            userkey: user_key,
          };
        } else {
          header = {};
        }

        if (ChartsData.apiData?.apiUrlMethod == 'get') {
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };
          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        } else {
          let params = ChartsData.apiData.apiPostParams || {};
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery
    getApiDataResByResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            console.log('getApiDataResByResponseQuery');
            console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        let filter = function (data, filter_text) {
          let dataSet = {};
          try {
            eval(filter_text);
          } catch (error) {
            console.log(error);
          }

          // debugger
          return dataSet;
        };
        this.getApiDataRes().then(res => {
          // query数据
          let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');

          if (arryQuery.length >= 1) {
            arryQuery.forEach(item => {
              res = res[item];
            });
          }
          // 判断是否使用过滤器
          if (ChartsData.apiData.isUseFilter) {
            res = filter(res, ChartsData.apiData.apiFilter);
            // debugger
          }
          console.log('getApiDataResByFilterAndResponseQuery');
          console.log(res);
          let data = this.$_.cloneDeep(res);
          resolve(data);
        });
      }).catch(error => {
        reject(error);
      });
    },
    // 创建 Echarts 需要准备好echartsOptions数据 具有reload效果
    createEcharts() {
      this.destroyEcharts();
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.init(mychartDom, 'dark');
      mychart.setOption(this.echartsOptions);
    },
    // 自适应缩放 Echarts 尺寸大小
    resizeEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.resize();
      }
    },
    // 更新 echartsOptions 数据
    updateEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.setOption(this.echartsOptions);
      } else {
        this.createEcharts();
      }
    },
    // 销毁 Echarts 实例
    destroyEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.clear();
        mychart.dispose();
      }
    },
  },

  Configuration: {
    componentTitle: '带背景色柱状图',
    componentName: 'Bar6Charts',
    componentOverViewImg: './img/charts/BarCharts/Bar6Charts.png',
    id: '',
    style: {
      width: 300,
      height: 150,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },
      chartsSubTitle: {
        value: '活动统计',
        lable: '图表内部标题',
        propertyComponentName: 'SingleInputor',
      },
      chartsSubTitleColor: {
        value: '#fff',
        lable: '图表内部标题颜色',
        propertyComponentName: 'SingleColorSelector',
      },
      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      chartsColor: {
        propertyComponentName: 'ArrayColorSelector',
        value: {
          chartColor: [
            'rgba(223,65,56,1)',
            'rgba(229,115,63,1)',
            'rgba(240,189,108,1)',
            'rgba(237,214,102,1)',
            'rgba(77,168,222,1)',
            'rgba(25,168,164,1)',
          ],
          chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
        },
      },
      ChartsData: {
        lable: '数据接入',
        propertyComponentName: 'ChartsDataConfigor',
        value: {
          currenEntry: 'staticData',
          apiData: {
            apiUrl:
              'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
            // apiUrl:
            // 'http://192.168.0.173/gthmmc_v4.0/gthmmc/index.php?m=sdms&c=dataMange&a=completeStatisticsdata&data=%7B%22type%22:%22%E6%80%BB%E6%95%B0%22,%22date_start%22:%222021-03-01%22,%22date_end%22:%222021-03-31%22%7D&directory_code=pro_ownerstatistics&type=day',
            apiResponseQuery: 'data.forecasts',
            isUseFilter: true,
            apiFilter: `
          // 可以使用data访问api请求的响应结果
let seriesList = []

let seriesListKey = 'city'
let seriesListChildrenKey = 'casts'

data.forEach((item) => {
  seriesList.push(item[seriesListKey])
})
dataSet.seriesList = seriesList
dataSet.source = []
data.forEach((item) => {
  item[seriesListChildrenKey].forEach(item2 => {
    dataSet.source.push({
      s: item[seriesListKey],
      x: item2.date,
      y: item2.daytemp
    })
  })
})
          `,
            isUseInterval: true,
            apiInterval: 10,
          },
          staticData: {
            seriesList: ['人数'],
            source: [
              {
                s: '人数',
                y: '5000',
                x: '亲子游乐',
                i: 1,
              },
              {
                s: '人数',
                y: '2600',
                x: '美容美发',
                i: 2,
              },
              {
                s: '人数',
                y: '1300',
                x: '文化展演',
                i: 3,
              },
              {
                s: '人数',
                y: '1250',
                x: '酒吧轰趴',
                i: 4,
              },
              {
                s: '人数',
                y: '1250',
                x: '康乐健身',
                i: 5,
              },
            ],
          },
        },
      },
      // 链接
      chartLink: {
        propertyComponentName: 'ChartsLinkConfiger',
        value: {
          isOpenLink: false, // 是否开启链接
          linkType: 'inner', // 链接类型 inner内链场景、outer外链地址
          linkUrl: '', // 链接url ，inner时是场景的id、outer时是http地址
        },
      },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 300,
          height: 150,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
          xAxisSize: 12,
          xAxisColor: '#c3dbff',
          yAxisSize: 12,
          yAxisColor: '#c3dbff',
        },
      },
      chartsGrid: {
        lable: '图表定位',
        propertyComponentName: 'ChartsGridConfiger',
        value: {
          left: '5%',
          right: '10%',
          bottom: '5%',
          top: '5%',
        },
      },
      showStatus: {
        value: 'norm',
      },
      // echartsRotate: {
      //   value: 0,
      // },
      chartUnit: {
        propertyComponentName: 'MapChartUnit',
        value: '单位(张)',
      },
      echartsRotate: {
        propertyComponentName: 'EchartsRotateConfiger',
        value: 0,
      },
      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
      chartsAnimation: {
        propertyComponentName: 'ChartsAnimationConfiger',
        value: {
          isUseAnimation: false,
          isUseStaticRefresh: false,
          staticRefreshIntervalTime: 5,
        },
      },
      chartsRightDropDown: {
        propertyComponentName: 'ChartsRightDropDownConfiger',
        value: {
          isShowRightDropDownBox: false,
        },
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.Bar6Charts {
  color: white;
  width: 100%;
  height: 100%;

  .echarts {
    width: 100%;
    height: 100%;
  }
  .no-data {
    width: 100%;
    height: 100%;
    // background: #000;
    position: absolute;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #ccc;
  }
  .TableDateDownSelect {
    position: absolute;
    top: 2px;
    right: 4px;
  }
}
// 加载样式

:deep().el-loading-spinner {
  .path {
    stroke: var(--color) !important;
  }

  p {
    display: flex !important;
    align-items: center !important;
    color: var(--color) !important;
  }
}

.link {
  // cursor:pointer;
  :deep()canvas {
    &:hover {
      // pointer-events: auto;
      cursor: pointer;
    }
  }
}
</style>
